import React, { useContext, useEffect, useState } from 'react';
import './TrialTopHeader.css';
import tooltipIcon from './images/alert-circle.svg';
import closeIcon from './images/close-x.svg';
import { AppDataContext } from '../../utils';
import { IBLSpinLoader } from '../IBLSpinLoader';

export const TrialTopHeader = ({
  fixedClassNamesToMove = '',
  descriptionText,
  pillDisplayText,
  tooltipText,
  handleClick,
  spaUsesMentorSidebar = false,
  loading=false
}) => {
  const { appData } = useContext(AppDataContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (spaUsesMentorSidebar) {
      if (appData?.sidebarCopilotTriggered) {
        //Copilot should be triggered first before toptrialheader shows up
        setVisible(true);
      }
    } else {
      setVisible(true);
    }
  }, [appData?.sidebarCopilotTriggered]);

  useEffect(() => {
    if(!visible){
      return
    }
    // Tooltip Handlers
    const handleMouseOver = (event: Event) => {
      const target = event.currentTarget as HTMLElement;
      const tooltip = target.querySelector('.tooltip-trial') as HTMLElement | null;
      if (tooltip) tooltip.style.display = 'block';
    };

    const handleMouseOut = (event: Event) => {
      const target = event.currentTarget as HTMLElement;
      const tooltip = target.querySelector('.tooltip-trial') as HTMLElement | null;
      if (tooltip) tooltip.style.display = 'none';
    };

    const containers = document.querySelectorAll('.top-header-icon-container');
    containers.forEach(container => {
      container.addEventListener('mouseover', handleMouseOver);
      container.addEventListener('mouseout', handleMouseOut);
    });

    // Additional Elements to Move Down
    if (fixedClassNamesToMove) {
      const elements = document.querySelectorAll(fixedClassNamesToMove);
      elements.forEach(element => {
        const computedStyle = window.getComputedStyle(element as HTMLElement);
        const currentTop = parseInt(computedStyle.top || '0', 10);
        (element as HTMLElement).style.top = `${currentTop + 30}px`;
      });
    }

    const body = document.body;
    const bodyPaddingTop = parseInt(window.getComputedStyle(body).paddingTop || '0', 10);
    body.style.paddingTop = `${bodyPaddingTop + 30}px`;

    // Trial Closure Handler
    const handleTrialClosure = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.closest('.top-header-closer-container')) {
        const trialHeader = document.querySelector('.ibl-trial-top-header') as HTMLElement | null;
        if (trialHeader) trialHeader.style.display = 'none';

        const updatedBodyPaddingTop = parseInt(window.getComputedStyle(body).paddingTop || '0', 10);
        body.style.paddingTop = `${updatedBodyPaddingTop - 30}px`;

        if (fixedClassNamesToMove) {
          const elements = document.querySelectorAll(fixedClassNamesToMove);
          elements.forEach(element => {
            const computedStyle = window.getComputedStyle(element as HTMLElement);
            const currentTop = parseInt(computedStyle.top || '0', 10);
            (element as HTMLElement).style.top = `${currentTop - 30}px`;
          });
        }
      }
    };

    document.addEventListener('click', handleTrialClosure);

    // Cleanup on unmount
    return () => {
      containers.forEach(container => {
        container.removeEventListener('mouseover', handleMouseOver);
        container.removeEventListener('mouseout', handleMouseOut);
      });
      document.removeEventListener('click', handleTrialClosure);
    };
  }, [visible]);

  return (
    visible && (
      <div className="site-top-header ibl-trial-top-header">
        <div className="w-layout-hflex site-top-header-container">
          <div
            data-w-id="16213f3d-be52-d559-0a8b-d87aa0856154"
            className="w-layout-hflex top-header-icon-container"
          >
            <img
              src={tooltipIcon}
              loading="lazy"
              height="20"
              alt=""
              className="top-header-img"
            />
            <div className="tooltip tooltip-trial" style={{ display: 'none' }}>
              {tooltipText}
            </div>
          </div>
          <div className="top-header-text">{descriptionText}</div>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              !loading && handleClick()
            }}
            className={`top-header-question-link w-inline-block ${loading ? "btn-disabled" : ""}`}
          >
            <div className="top-header-text pill">{pillDisplayText} {
              loading && (
                <span style={{marginLeft:"5px"}}><IBLSpinLoader size={15} color={"#FFF"} /></span>
              )
            }</div>
          </a>
          <div
            prop-events-value-onclick="handleTopHeaderCloseClick"
            prop-events-names="onClick"
            className="w-layout-hflex top-header-closer-container"
          >
            <img
              src={closeIcon}
              loading="lazy"
              alt=""
              className="top-header-closer-icon"
            />
          </div>
        </div>
      </div>
    )
  );
};
